"use strict";

function workerInstalled(event) {
  global.skipWaiting();
  console.log("Worker installed: ", event);
}

function workerActivate(event) {}

function workerPush(event) {
  var data = event.data.json();
  var title = data.title,
      body = data.body,
      icon = data.icon,
      image = data.image,
      url = data.url,
      actions = data.actions;
  icon = icon || '';
  image = image || '';
  var options = {
    body: body,
    icon: icon,
    image: image,
    data: {
      url: url
    },
    actions: actions
  };
  event.waitUntil(global.registration.showNotification(title, options));
}

function workerClick(event) {
  event.notification.close();
  var promise = event.notification.data.url ? clients.openWindow(event.notification.data.url) : Promise.resolve(true);
  event.waitUntil(promise);
}

global.addEventListener('install', workerInstalled);
global.addEventListener('activate', workerActivate);
global.addEventListener('push', workerPush);
global.addEventListener('notificationclick', workerClick);